module.exports = __webpack_public_path__ + "img/user.6f6bbb16.png";